import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { customerIdSelector } from "@/react/features/customer/customerSlice";
import { CustomerCard } from "@/react/features/customer/card";
import { Licenses } from "@/react/features/smp/licenses/components/Licenses";
import { InfoSmallIcon } from "@8x8/oxygen-icon";
import Tooltip from "@8x8/oxygen-tooltip";
import PageTitle from "@/react/components/PageTitle";
import PageLayout from "@/react/features/styled/PageLayout";

const StyledTitle = styled(PageTitle)`
  margin: 0 0 16px;
`;

export function LicensesPage() {
  const customerId = useSelector(customerIdSelector);

  return (
    <PageLayout>
      <CustomerCard />
      {!customerId && <div>Select a customer</div>}
      {customerId && (
        <>
          <Tooltip
            title={
              "View and filter unassigned licenses. Update the service address or delete selected licenses (requires Cancellation Okta Group)"
            }
          >
            <StyledTitle>
              Licenses <InfoSmallIcon />
            </StyledTitle>
          </Tooltip>
          <Licenses />
        </>
      )}
    </PageLayout>
  );
}
